document.addEventListener("DOMContentLoaded", () => {
  const OpenModal = document.querySelectorAll(".view-sizing");
  const Modal = document.querySelector(".modal-sizing");
  const CloseModal = document.querySelector(".button-close");

  OpenModal.forEach(open => {
    open.addEventListener('click', togglerClick)
  })

  // OpenModal.addEventListener("click", togglerClick);
  CloseModal.addEventListener("click", togglerClick);

  function togglerClick() {
    if (Modal.classList.contains("open")) {
      Modal.classList.remove("open");
    } else {
      Modal.classList.add("open");
    }
  }
});
